import PropTypes from "prop-types";
import React from "react";
import DataGrid, { DataGridItem } from "components/data-grid";
import { injectIntl } from "react-intl";
import I18nBoolean from "components/i18n-boolean";
import styles from "./styles.css.js";
import withStyles from "components/with-styles";
import { LinkWithIcon } from "components/link";
import { TextDisplay } from "components/display-data";
import Chip from "components/chip";
import permissions from "../../../components/auth/restricted/permissions";
import Restricted from "../../../components/auth/restricted/restricted";
import SelectEventTypeOnContract from "./partial/select-event-type-on-contract.jsx";

const ContractData = ({ contract, intl, classes }) => {
  return !contract ? null : (
    <DataGrid>
      <DataGridItem big>
        <div className={classes.title}>{contract.name}</div>
        <div className={classes.subtitle}>{contract.description}</div>
        <DataGrid big>
          <DataGridItem>
            {contract.customer && (
              <LinkWithIcon
                iconName="business-center"
                href={`/customer/details/${contract.customer.id}`}
                text={contract.customer?.description}
              />
            )}
          </DataGridItem>
          <DataGridItem>
            {contract.deployment && (
              <LinkWithIcon
                iconName="settings-input-antenna"
                href={`/deployment/details/${contract.deployment.id}`}
                text={contract.deployment.codename}
              />
            )}
          </DataGridItem>
        </DataGrid>
      </DataGridItem>
      <DataGridItem>
        <TextDisplay className={classes.data} label={intl.formatMessage({ id: "contract.allowedMasterStreamSave" })}>
          <I18nBoolean value={contract.allowedMasterStreamSave} />
        </TextDisplay>
      </DataGridItem>
      <DataGridItem>
        <TextDisplay className={classes.data} label={intl.formatMessage({ id: "contract.bannerSupport" })}>
          <I18nBoolean value={contract.bannerSupport} />
        </TextDisplay>
      </DataGridItem>
      <DataGridItem>
        <TextDisplay className={classes.data} label={intl.formatMessage({ id: "contract.scoreboardSupport" })}>
          <I18nBoolean value={contract.scoreboardSupport} />
        </TextDisplay>
      </DataGridItem>
      <DataGridItem>
        <TextDisplay className={classes.data} label={intl.formatMessage({ id: "contract.liveCommentatorSupport" })}>
          {contract.liveCommentatorSupport}
        </TextDisplay>
      </DataGridItem>
      <DataGridItem>
        <TextDisplay className={classes.data} label={intl.formatMessage({ id: "contract.monthlyTiiviiHours" })}>
          {contract.monthlyTiiviiHours}
        </TextDisplay>
      </DataGridItem>
      <DataGridItem>
        <TextDisplay className={classes.data} label={intl.formatMessage({ id: "contract.keepVideosForMonths" })}>
          {contract.keepVideosForMonths}
        </TextDisplay>
      </DataGridItem>
      <DataGridItem>
        <TextDisplay className={classes.data} label={intl.formatMessage({ id: "contract.allowedProductionTypes" })}>
          {contract.allowedProductionTypes &&
            contract.allowedProductionTypes.map(item => (
              <Chip className={classes.chip} key={item.id} label={item.description} />
            ))}
        </TextDisplay>
      </DataGridItem>
      <DataGridItem>
        <TextDisplay className={classes.data} label={intl.formatMessage({ id: "contract.allowedIAAlgorithms" })}>
          {contract.allowedIAAlgorithms &&
            contract.allowedIAAlgorithms.map(item => (
              <Chip className={classes.chip} key={item.id} label={item.description} />
            ))}
        </TextDisplay>
      </DataGridItem>
      <Restricted permissions={[permissions.customer_view]}>
        {contract?.tiiviiOttConfig && (
          <>
            <DataGridItem big>
              <TextDisplay
                className={classes.data}
                label={intl.formatMessage({ id: "contract.ottConfigEnabledField" })}
              >
                <I18nBoolean value={contract?.tiiviiOttConfig?.enabled} />
              </TextDisplay>
            </DataGridItem>
            {contract?.tiiviiOttConfig?.webhookUrl && (
              <DataGridItem big>
                <TextDisplay className={classes.data} label={intl.formatMessage({ id: "contract.ottconfig.webhook" })}>
                  {contract?.tiiviiOttConfig?.webhookUrl}
                </TextDisplay>
              </DataGridItem>
            )}
            {contract?.tiiviiOttConfig?.nimbleConfigUrl && (
              <DataGridItem big>
                <TextDisplay
                  className={classes.data}
                  label={intl.formatMessage({ id: "contract.ottconfig.nimbleconfigurl" })}
                >
                  {contract?.tiiviiOttConfig?.nimbleConfigUrl}
                </TextDisplay>
              </DataGridItem>
            )}
          </>
        )}
      </Restricted>
      <DataGridItem>
        <TextDisplay className={classes.data} label={intl.formatMessage({ id: "contract.allowedEventTypes" })}>
          {contract.allowedEventTypes &&
            contract.allowedEventTypes.map(item => (
              <Chip className={classes.chip} key={item.id} label={item.description} />
            ))}
        </TextDisplay>
      </DataGridItem>
      <Restricted permissions={[permissions.contract_view, permissions.contract_manage]}>
        <DataGrid>
          <DataGridItem>
            <TextDisplay className={classes.data}>
              {intl.formatMessage({ id: "contract.ocurrenceSource.title" })}
            </TextDisplay>
            <SelectEventTypeOnContract
              intl={intl}
              items={contract.allowedEventTypes}
              contractId={contract.id}
              styles={classes}
            />
          </DataGridItem>
        </DataGrid>
      </Restricted>
    </DataGrid>
  );
};

ContractData.propTypes = {
  /**
   * Data to represent
   **/
  contract: PropTypes.object,
};

export default injectIntl(withStyles(styles)(ContractData));
